import React from 'react'
import { useLocation } from 'react-router-dom'

import { Box, Breakpoint, Grid, GridSpan, Text } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { Download } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

import {
  MarketplaceFeature as FeatureBlock,
  FeatureBlocksProps,
} from 'modules/marketplace_modules/components/Revamp/types'
import { downloadPdf } from 'modules/marketplace_modules/components/utils/downloadPdf'

import { FeatureItem } from './_Item'

const FeatureBlocks: React.FC<FeatureBlocksProps> = ({ features, module, pitchDeck }) => {
  const { pathname } = useLocation()
  const gridColSpan: { [key in Breakpoint]?: GridSpan } = {
    xxs: 12,
    s: 6,
  }

  const validFeatures =
    features?.filter((feature): feature is { emoji: string; title: string; description: string } =>
      Boolean(feature.emoji && feature.title && feature.description)
    ) || []

  const handleDownloadPitchDeck = async () => {
    const pitchDeckUrl = pitchDeck?.[0]?.url

    if (!pitchDeckUrl || !module) {
      return
    }

    await downloadPdf({
      url: pitchDeckUrl,
      module,
      source: 'marketplace_feature_blocks_download',
      origin: pathname,
    })
  }

  if (validFeatures.length === 0) {
    return null
  }

  return (
    <Box paddingY="s24">
      <Box paddingBottom="s24" flexDirection="row" justifyContent="spaceBetween">
        <Text size="300" weight="semibold" color="black">
          {i18n.t('marketplace.revamp.why_teams_choose', {
            module_name: module,
          })}
        </Text>
        {pitchDeck?.[0]?.url && (
          <F0Button
            icon={Download}
            label={i18n.t('marketplace.revamp.download_overview')}
            variant="outline"
            onClick={handleDownloadPitchDeck}
          />
        )}
      </Box>
      <Grid variant="fixed">
        {validFeatures.map((feature) => (
          <Box key={feature.title} gridColSpan={gridColSpan}>
            <FeatureItem feature={feature} />
          </Box>
        ))}
      </Grid>
    </Box>
  )
}

export default FeatureBlocks
export type { FeatureBlock }
